import {
  Form,
  Input,
  Select,
  InputNumber,
  Checkbox,
  Button,
  Card,
  Spin,
  Tag,
  Icon,
  Tooltip,
} from "antd";
import React, { Component } from "react";
import { showSuccessToast, showErrorToast } from "../general/ToastHelper";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { PackageAndPrivilegeService } from "../../services/packageAndPrivilege/PackageAndPrivilegeService";
import { withRouter } from "react-router-dom";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "../accounts/Accounts.css";
import "../accounts/AccountForm.css";
import "../accounts/CreateAccount.css";
import AuthorizedOnly from "../general/AuthorizedOnly";
import { Constants } from "../../data/constants";

class UpdatePackage extends Component {
  packageAndPrivilegeService = new PackageAndPrivilegeService();
  constants = new Constants();
  constructor(props) {
    super(props);
     this.props.context.setCurrentComponent("editPackages");
    this.state = {
      pkg: {},
      isFetching: false,
      formLayout: "inline",
      loading: false,
      inputValue: "",
      packages: [],
      
    };
  }

  async componentDidMount() {
    let { pkg } = this.state;
    pkg.pkgCode = this.props.match.params.pkgCode;
    pkg.pkgName = this.props.match.params.pkgName;
    pkg.pkgRatio = this.props.match.params.pkgRatio;

    this.setState({ pkg });

  }
 
  handleConfirm = (e) => {
    e.preventDefault();
    let history = this.props.history;
    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          this.setState({ loading: true });
          values.pkgCode = this.props.match.params.pkgCode;
          let data = await this.packageAndPrivilegeService.editPackage(
            this.props.context.session_id,
            values
          );
          showSuccessToast("Package Updated Successfully");
          this.setState({ loading: false });
          this.props.form.resetFields();
          history.push("/home/packages");
        }
      } catch (e) {
        this.setState({ loading: false, visible: false });
        handleError(e);
      }
    });
  };

 

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    let { isFetching } = this.state;
    return (
      <Page title={"Update Package"} hasBackArrow={true}>
        {isFetching ? (
          <Spin></Spin>
        ) : (
          <Card
            style={{
              marginTop: "10px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
            }}
            bordered={false}
          >
            <Form className="form-style" {...formItemLayout}>
              <Form.Item label="Package Code" {...formItemLayout}>
                <label>{this.state.pkg.pkgCode} </label>
              </Form.Item>
              <Form.Item label="Package Name" {...formItemLayout}>
                {getFieldDecorator(
                  "pkgName",

                  {
                    initialValue: this.state.pkg.pkgName,
                    rules: [
                      {
                        required: true,
                        message: "Please enter valid package name",
                      },
                    ],
                  }
                )(<Input />)}
              </Form.Item>
              {/* <Form.Item label="Package Ratio" {...formItemLayout}>
                {getFieldDecorator(
                  "pkgRatio",

                  {
                    initialValue: this.state.pkg.pkgRatio,
                    rules: [
                      {
                        required: true,
                        message: "Please enter valid package ratio",
                      },
                    ],
                  }
                )(<Input />)}
              </Form.Item> */}

              <Form.Item
                wrapperCol={{
                  xs: { span: 24, offset: 0 },
                  sm: { span: 16, offset: 8 },
                }}
              >
                <Button
                  className="button-submit"
                  type="primary"
                  onClick={this.handleConfirm}
                  size={"small"}
                  loading={this.state.loading}
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Card>
        )}
      </Page>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(UpdatePackage))
);
